import React from 'react';
import { amenitiesData } from '../../data';

const Amenities = () => {
  return (
    <section className="py-16">
      <div className="text-center mb-8">
        <h2 className="text-[14px] font-semibold text-[#132430] mb-3">AMENITIES</h2>
        <h1 className="text-[26px] md:text-[64px] font-semibold md:font-bold text-[#1b1b1b] leading-[100%] mb-8 md:mb-12">Included with every stay</h1>
      </div>
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-6 md:gap-12">
          {amenitiesData.map((amenity, index) => (
            <div key={index} className="flex flex-col items-center text-center">
              <div className="mb-4 border-icon-service">
                <img src={amenity.icon} alt={amenity.title} className="h-[36px] max-h-[36px] min-h-[36px]" />
              </div>
              <h3 className="text-[16px] md:text-[18px] md:text-xl font-semibold text-[#1b1b1b]">{amenity.title}</h3>
              {amenity.comingSoon && <span className="text-[12px] text-red-500">Coming Soon</span>}
              <p className="mt-2 text-[#757575] text-[14px] md:text-[16px] font-light max-w-[94%] md:max-w-[85%]">{amenity.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Amenities;
